import { supabase } from '../config/supabaseClient.js';
import { norm } from './dom.js';

/**
 * Busca TODAS as linhas de uma consulta, contornando o teto de ~1000 linhas
 * POR REQUISICAO do PostgREST/Supabase (que o .limit() NAO ultrapassa).
 * Pagina com .range() ate a pagina vir incompleta. Passe uma FABRICA de query.
 */
export async function buscarTodos(fabricaQuery, { pagina = 1000, max = 100000 } = {}) {
  let todos = [];
  for (let de = 0; ; de += pagina) {
    const { data, error } = await fabricaQuery().range(de, de + pagina - 1);
    if (error) throw new Error(error.message);
    if (!data || !data.length) break;
    todos = todos.concat(data);
    if (data.length < pagina || todos.length >= max) break;
  }
  return todos;
}

export { supabase };

// Remove curingas e separadores que quebrariam o .or() do PostgREST (mantem letras/acentos/aspostrofo).
function limpaTermo(termo) { return (termo || '').trim().replace(/[%,()]/g, ' ').trim(); }

/**
 * Filtro para buscar pessoa por nome, CPF ou matricula usando as COLUNAS GERADAS
 * cpf_digitos/matricula_digitos (so digitos) — casa inicio, MEIO e FIM, sem depender
 * da pontuacao gravada. Requer a migration 0044 (ha fallback: orBuscaPessoaLegado).
 */
export function orBuscaPessoa(termo) {
  const t = limpaTermo(termo);
  if (!t) return '';
  const dig = t.replace(/\D/g, '');
  if (dig) return `nome.ilike.%${t}%,cpf_digitos.ilike.%${dig}%,matricula_digitos.ilike.%${dig}%`;
  return `nome.ilike.%${t}%,cpf.ilike.%${t}%,matricula.ilike.%${t}%`;
}

/** Fallback (sem a 0044): agrupa os digitos pelos blocos do CPF — so casa prefixo ancorado. */
export function orBuscaPessoaLegado(termo) {
  const t = limpaTermo(termo);
  if (!t) return '';
  const dig = t.replace(/\D/g, '');
  if (dig) { const p = padraoDocumento(dig); return `nome.ilike.%${t}%,cpf.ilike.${p},matricula.ilike.${p}`; }
  return `nome.ilike.%${t}%,cpf.ilike.%${t}%,matricula.ilike.%${t}%`;
}

/** Igual a orBuscaPessoa, mas so nome + CPF (ex.: visitantes, sem matricula). */
export function orBuscaNomeCpf(termo) {
  const t = limpaTermo(termo);
  if (!t) return '';
  const dig = t.replace(/\D/g, '');
  if (dig) return `nome.ilike.%${t}%,cpf_digitos.ilike.%${dig}%`;
  return `nome.ilike.%${t}%,cpf.ilike.%${t}%`;
}

/** Fallback do anterior (sem a 0044). */
export function orBuscaNomeCpfLegado(termo) {
  const t = limpaTermo(termo);
  if (!t) return '';
  const dig = t.replace(/\D/g, '');
  if (dig) return `nome.ilike.%${t}%,cpf.ilike.${padraoDocumento(dig)}`;
  return `nome.ilike.%${t}%,cpf.ilike.%${t}%`;
}

// Agrupa os digitos pelos blocos do CPF (3-3-3-2) e une com "%" (cobre a pontuacao gravada),
// mantendo cada bloco contiguo. Usado so nos fallbacks "Legado".
function padraoDocumento(dig) {
  const grupos = [];
  let ini = 0;
  for (const fim of [3, 6, 9, 11]) {
    if (ini >= dig.length) break;
    grupos.push(dig.slice(ini, Math.min(fim, dig.length)));
    ini = fim;
  }
  if (ini < dig.length) grupos.push(dig.slice(ini));
  return '%' + grupos.join('%') + '%';
}

/** Marca c.homonimo=true para nomes que aparecem 2+ vezes no resultado (alerta de identificacao). */
export function marcarHomonimos(lista) {
  const cont = new Map();
  for (const c of lista || []) { const k = norm(c.nome || ''); cont.set(k, (cont.get(k) || 0) + 1); }
  (lista || []).forEach((c) => { c.homonimo = cont.get(norm(c.nome || '')) > 1; });
  return lista || [];
}